import { useState, useCallback } from 'react';

export const useBoolean = (defaultValue = false) => {
  const [value, setValue] = useState(defaultValue);

  const toggle = useCallback(() => setValue((old) => !old), []);
  const off = useCallback(() => setValue(false), []);
  const on = useCallback(() => setValue(true), []);

  return [value, { toggle, off, on }];
};
